import { globalActor } from "../../state/GlobalContextProvider";

export default function ReadyScreen() {
  return (
    <div className="Screen ReadyForStart">
      <div>
        <button
          onClick={(_) => {
            globalActor.send({ type: "START_EXPERIENCE" });
            window.doTime = true;
          }}
        >
          START THE MIEBO EXPERIENCE
        </button>
        <button
          className="Skip"
          onClick={(_) => globalActor.send({ type: "TOGGLE_MENU" })}
        >
          Skip to
        </button>
      </div>
    </div>
  );
}
